import type { StoryObject } from '@benzinga/advanced-news-manager';
import type { News } from '@benzinga/basic-news-manager';
import { ArticleData } from '../entities/article';
import { isChanneled, isContentAutomated, isTagged } from './checks';

export type PaywallInput = ArticleData | StoryObject | News;

const paywallTags = {
  'alpha-buying': 1004003,
  'c-suite-buys-of-the-week': 943954,
  'easy-income-portfolio': 944696,
  'insider-report': 938584,
  // interviews: 714112,
  // mavens: 154244,
  'options-trade-of-the-day': 946635,
  'perfect-stock-portfolio': 944719,
  'stock-of-the-day': 931449,
  'stock-whisper-index': 866728,
  'under-the-radar': 943823,
};

const paywallTagNames = new Set(Object.keys(paywallTags));

export const getPaywallType = (article: ArticleData) => {
  if (isTagged(article, Object.values(paywallTags))) return 'hard';

  return 'soft-hard';
};

export const isPaywallArticle = (article: PaywallInput): boolean => {
  const uid =
    ('userId' in article ? article.userId : undefined) ??
    (typeof article.author === 'object' ? article.author?.uid : undefined);
  if ((uid && isContentAutomated(uid)) || article.author === 'Benzinga Insights') return true;

  const tagNames = article.tags?.map(t => t?.name ?? '').filter(Boolean) ?? [];
  return (
    isTagged({ tags: (article.tags ?? []) as ArticleData['tags'] }, Object.values(paywallTags)) ||
    tagNames.some(name => paywallTagNames.has(name.toLowerCase().trim().replace(/\s+/g, '-')))
  );
};

export const getPaywallContentType = (article: ArticleData) => {
  if (isTagged(article, [931449])) return 'stock-of-the-day';
  if (isTagged(article, [866728])) return 'whisper-index';
  if (isChanneled(article, [68])) return 'analyst-color';
  if (isTagged(article, [944696])) return 'easy-income-portfolio';
  if (isTagged(article, [944719])) return 'perfect-stock-portfolio';
  // if (isTagged([938584])) return 'insider-report';
  return 'default-article';
};
